
  export const TRACKS_RECEIVED = "TRACKS_RECEIVED";
  export const SET_TRACK = "SET_TRACK";
  export const CREATE_TRACK = "CREATE_TRACK";
  export const SET_PROPERTY_TRACK = "SET_PROPERTY_TRACK";
  